import { render, staticRenderFns } from "./pagestatus.vue?vue&type=template&id=6ec3d96c&scoped=true&"
import script from "./pagestatus.vue?vue&type=script&lang=js&"
export * from "./pagestatus.vue?vue&type=script&lang=js&"
import style0 from "./pagestatus.vue?vue&type=style&index=0&id=6ec3d96c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3d96c",
  null
  
)

export default component.exports